import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch {
        setState("error");
        return;
      }
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#08080a] text-zinc-100 flex items-center justify-center px-4">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        {state === "loading" && (
          <>
            <Loader2 size={48} className="animate-spin text-blue-500 mx-auto mb-6" />
            <h1 className="font-display font-bold text-3xl mb-3">Vérification du paiement...</h1>
            <p className="text-zinc-400">Nous confirmons votre transaction auprès de Stripe.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-emerald-400 mx-auto mb-6" />
            <h1 className="font-display font-bold text-3xl mb-3" data-testid="payment-confirmed-title">
              Paiement confirmé
            </h1>
            <p className="text-zinc-400 mb-8">
              Merci ! Votre paiement a bien été reçu. Je reviens vers vous très vite pour la suite du projet.
            </p>
            <Link
              to="/"
              className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-300"
              data-testid="back-home-button"
            >
              Retour à l'accueil
            </Link>
          </>
        )}
        {state === "pending" && (
          <>
            <Loader2 size={48} className="text-blue-500 mx-auto mb-6" />
            <h1 className="font-display font-bold text-3xl mb-3">Paiement en cours de traitement</h1>
            <p className="text-zinc-400 mb-8">Votre banque traite encore la transaction. Vous recevrez une confirmation par e-mail.</p>
            <Link to="/" className="inline-block border border-white/15 px-7 py-3.5 rounded-full hover:border-blue-500 transition-colors duration-300" data-testid="back-home-button">
              Retour à l'accueil
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={56} className="text-red-400 mx-auto mb-6" />
            <h1 className="font-display font-bold text-3xl mb-3">Une erreur est survenue</h1>
            <p className="text-zinc-400 mb-8">Impossible de vérifier ce paiement. Contactez-moi si le problème persiste.</p>
            <Link to="/" className="inline-block border border-white/15 px-7 py-3.5 rounded-full hover:border-blue-500 transition-colors duration-300" data-testid="back-home-button">
              Retour à l'accueil
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
